import React from 'react';
import JobTableContainer from '../container/job-table.container';
import JobDetailsContainer from '../container/job-details.container';
import TenantGuard from '@components/common/TenantGuard';

export const jobRoutes = [
  {
    path: 'jobs',
    element: (
      <TenantGuard showHeader={true} headerTitle="Jobs" showBreadcrumbs={true}>
        <JobTableContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'jobs/:id',
    element: (
      <TenantGuard showHeader={true} headerTitle="Job Details" showBreadcrumbs={true}>
        <JobDetailsContainer />
      </TenantGuard>
    ),
  },
];

export default jobRoutes;
